/**
 * @copyright: 2020 NTWIST.
 * @Author: NTWIST
 * @Date: 2022-04-13 12:03:31
 * @Last Modified by: Pradeep Chandra
 * @Last Modified time: 2022-07-19 10:53:43
 */

import axios from "axios";
import { toaster, Message } from "rsuite";
import React from "react";
import BaseURL from "../api-common";

export async function getLatestLevelPrediction(endUserSession, clientPathName) {
    try {
        let url =
            BaseURL.getBaseURL() +
            clientPathName +
            "/predictionModel/getLatestLevelPrediction";
        let res = await axios({
            method: "get",
            url: url,
            withCredentials: true,
            data: {}
        });

        if (res.data.msg === "UNAUTHORIZED") {
            endUserSession();
            return;
        } else if (res.data.statusId === "ERROR") {
            throw "The server has encountered an error.";
        } else if (!res.data.isValidData) {
            throw "The request is invalid.";
        }

        return res.data;
    } catch (e) {
        toaster.push(
            <Message type="error" showIcon closable duration={10000}>
                {
                    <text>
                        Could not get level prediction details.
                        <br />
                        Error: {e.toString()}
                    </text>
                }
            </Message>
        );
        return null;
    }
}

export async function getDemoLevelPredictionData(
    endUserSession,
    clientPathName,
    data
) {
    try {
        let url =
            BaseURL.getBaseURL() +
            clientPathName +
            "/predictionModel/getDemoLevelPredictionData";
        let res = await axios({
            method: "post",
            url: url,
            withCredentials: true,
            data: data
        });

        if (res.data.msg === "UNAUTHORIZED") {
            endUserSession();
            return;
        } else if (res.data.statusId === "ERROR") {
            throw "The server has encountered an error.";
        } else if (!res.data.isValidData) {
            throw "The request is invalid.";
        }

        return res.data;
    } catch (e) {
        toaster.push(
            <Message type="error" showIcon closable duration={10000}>
                {
                    <text>
                        Could not get level prediction details.
                        <br />
                        Error: {e.toString()}
                    </text>
                }
            </Message>
        );
        return null;
    }
}
